<template>
   <div class="bg-(--brand-primary) text-white text-center text-xs font-medium py-3">
      <span class="mx-4 tracking-[1.28px]">FIND OUT IF YOU QUALIFY FOR A CLAIM IN SECONDS</span>
    </div>
</template>
